import {
  DotLoading,
  List,
  Modal,
  Popup,
  Tag,
  Toast,
  Tabs,
  Dialog,
} from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Button, Col, Form, Row, Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import PsContext from "../../context";
import { currentSemesterStartAndEndDate } from "../../models/academicYears";
import {
  momentDate,
  timeTableDayFromNumber,
  jsonToQuery,
  MOB_ICONS,
} from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import { FloatButton, Avatar, Space, Spin } from "antd";
import $ from "jquery";
import Header from "../header";
const MyLeaveList = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [showView, setShowView] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [employeeLeaves, setEmployeeLeaves] = useState([]);
  const [dataView, setDataView] = useState([]);
  const [showList, setShowList] = useState(true);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showListView, setShowListView] = useState(false);
  const [rolesAccess, setRolesAccess] = useState(false);
  const [totalCount, setTotalCount] = useState("");
  const [leaveCount, setLeaveCount] = useState([]);
  const [activeTab, setActiveTab] = useState("myleave");
  const [pendingCount, setPendingCount] = useState(0);
  const [holidays, setHolidays] = useState([]);
  const [day, setDay] = useState();
  const [selectedLeaves, setSelectedLeaves] = useState([]);

  const [fromDate, setFromDate] = useState(
    momentDate(new Date(), "YYYY-MM-DD")
  );
  const [toDate, setToDate] = useState(momentDate(new Date(), "YYYY-MM-DD"));
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 50,
    },
    total: 0,
  });

  useEffect(() => {
    axios.post(ServiceUrl.MOB.EMP_HOLIDAY_LIST).then((res) => {
      if (res["data"].status == "1") {
        setHolidays(res["data"].data);
      } else {
        Toast.show({ content: res["data"].message || "Error" });
      }
      setLoader(false);
    });
  }, []);

  useEffect(() => {
    getLeaveTypes();
    if (!loader) getReport();
  }, [JSON.stringify(tableParams.pagination)]);

  const getRandomuserParams = (params) => ({
    limit: params.pagination?.pageSize,
    page: params.pagination?.current,
    name: params.pagination?.name,
    from_date: params.pagination?.from_date,
    to_date: params.pagination?.to_date,
    // academic_department: params.pagination?.academic_department,
    //...params,
  });

  const getReport = () => {
    setLoader(true);
    setDataList([]);
    setDataView([]);
    const form = new FormData();
    form.append("staff_id", context.user.id);
    form.append("role_id", context.user.emp_role_id);
    form.append("academic_department", context.user.emp_academic_department);
    axios
      .post(
        ServiceUrl.MOB.EMP_LEAVE_LIST +
          "?" +
          jsonToQuery(getRandomuserParams(tableParams)),
        form
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setDataList(res["data"].data);
          setDataView(res["data"].data);
          setTableParams({
            ...tableParams,
            pagination: {
              ...tableParams.pagination,
              total: res["data"].count,
              // 200 is mock data, you should read it from server
              // total: data.totalCount,
            },
          });

          setEmployeeLeaves(res["data"].employee_leaves);
          if (res["data"].rolesaccess > 0) setRolesAccess(true);

          setTotalCount(res["data"].totalapprovalcount);
        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }
        setLoader(false);
      });
  };
  const onLeaveChange = (e) => {
    setPendingCount(0);
    let m = leaveTypes.filter((obj) => obj.leave_type == e);
    getLeaveCount(context.user.id, m[0].id);
  };

  const getLeaveCount = (e, leaveid) => {
    axios
      .get(
        ServiceUrl.MOB.EMPLOYEES_LEAVE_PERMISSION +
          "?status=1&type=leave&emp_id=" +
          e +
          "&leaveid=" +
          leaveid +
          "&from_date=" +
          fromDate
      )
      .then((res) => {
        if (res["data"].status == "1") {
          setLeaveCount(res["data"].allowedleaves);
          if (fromDate && toDate)
            calculateDays(toDate, res["data"].allowedleaves);
        } else {
          //toast.error(res["data"].message || "Error");
        }
        setLoader(false);
      });
  };
  const getLeaveTypes = () => {
    const form = new FormData();
    form.append("emp_id", context.user.id);
    form.append("role_id", context.user.emp_role_id);

    axios.post(ServiceUrl.MOB.EMP_LEAVE_TYPES_LIST, form).then((res) => {
      if (res["data"].status == "1") {
        setLeaveTypes(res["data"].data);
      } else {
        Toast.show({ content: res["data"].message || "Error" });
      }
      setLoader(false);
    });
  };
  // console.log(showView.name);
  const handleView = (item) => {
    setShowView(item);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
    Toast.show("Processing...");
    const form = new FormData();
    form.append("staff_id", context.user.id);
    axios
      .post(ServiceUrl.MOB.EMP_LEAVE_SAVE, $("#frm_add").serialize())
      .then((res) => {
        if (res["data"].status == "1") {
          Toast.show({ content: res["data"].message || "Saved" });
          setShowList(true);

          setShowForm(false);
          getReport();
          setLoader(false);
          document.getElementById("frm_add").reset();
        } else {
          Toast.show({ content: res["data"].message || "Error" });
          setLoader(false);
        }
      });
  };
  function handleApproval(type, item) {
    const form = new FormData();
    form.append("emp_id", item.emp_id);
    form.append("emp_name", item.emp_name);
    form.append("emp_code", item.emp_code);
    form.append("leave_from_date", item.from_date);
    form.append("leave_to_date", item.to_date);
    form.append("leave_id", item.id);
    form.append("leave_ids", item.leave_id);
    form.append("leave_type", item.leave_type);
    form.append("leave_count", item.leavecount);
    form.append("approved_by", context.user.id);
    form.append("totalcount", totalCount);
    form.append("approvalcount", item.approvalcount);
    form.append("department", context.user.emp_academic_department);

    if (type == "approved") {
      Dialog.confirm({
        title: "Do you want to approve ?",
        confirmText: "Yes",
        cancelText: "Cancel",
        onConfirm: () => {
          Toast.show("Processing...");
          form.append("approved_status", 1);
          axios.post(ServiceUrl.MOB.EMP_LEAVE_APPROVAL, form).then((res) => {
            if (res["data"].status == "1") {
              Toast.show({ content: res["data"].message || "Approved" });
              getReport();
            } else {
              Toast.show({ content: res["data"].message || "Error" });
            }
          });
        },
      });
    } else {
      Dialog.confirm({
        title: "Do you want to reject?",
        confirmText: "Yes",
        cancelText: "Cancel",
        content: (
          <Form.Control
            as="textarea"
            name="reason"
            id="reason"
            className="fw-bold mt-2"
            placeholder="Please enter reason"
            size="md"
            rows="3"
            required
          />
        ),
        onConfirm: () => {
          Toast.show("Processing...");
          form.append("approved_status", 0);
          form.append("reason", $("#reason").val());
          axios.post(ServiceUrl.MOB.EMP_LEAVE_APPROVAL, form).then((res) => {
            if (res["data"].status == "1") {
              Toast.show({ content: res["data"].message || "Rejected" });
              getReport();
            } else {
              Toast.show({ content: res["data"].message || "Error" });
            }
          });
        },
      });
    }
  }


  
  function handleHODApproval(type, item) {
    const form = new FormData();
    form.append("emp_id", item.emp_id);
    form.append("emp_name", item.emp_name);
    form.append("emp_code", item.emp_code);
    form.append("leave_from_date", item.from_date);
    form.append("leave_to_date", item.to_date);
    form.append("leave_id", item.id);
    form.append("leave_ids", item.leave_id);
    form.append("leave_type", item.leave_type);
    form.append("leave_count", item.leavecount);
    form.append("approved_by", context.user.id);
    form.append("totalcount", totalCount);
    form.append("approvalcount", item.approvalcount);
    form.append("department", context.user.emp_academic_department);

    Dialog.confirm({
      title: "Do you want to Endorse?",
      confirmText: "Yes",
      cancelText: "Cancel",
      content: (
        <Form.Control
          as="textarea"
          name="reason"
          id="reason"
          className="fw-bold mt-2"
          placeholder="Please enter reason"
          size="md"
          rows="3"
          required
        />
      ),
      onConfirm: () => {
        Toast.show("Processing...");
        form.append("approved_status", 0);
        form.append("reason", $("#reason").val());
        axios.post(ServiceUrl.MOB.EMP_LEAVE_APPROVAL, form).then((res) => {
          if (res["data"].status == "1") {
            Toast.show({ content: res["data"].message || "Rejected" });
            getReport();
          } else {
            Toast.show({ content: res["data"].message || "Error" });
          }
        });
      },
    });
  }


  const approveSelectedLeaves = () => {
    const selected = employeeLeaves.filter(item => selectedLeaves.includes(item.id));
    if (selected.length === 0) {
      Toast.show({ content: "No leave requests selected." });
      return;
    }

    const approvalPromises = selected.map(item => {
      const form = new FormData();
      form.append("emp_id", item.emp_id);
      form.append("emp_name", item.emp_name);
      form.append("emp_code", item.emp_code);
      form.append("leave_from_date", item.from_date);
      form.append("leave_to_date", item.to_date);
      form.append("leave_id", item.id);
      form.append("leave_ids", item.leave_id);
      form.append("leave_type", item.leave_type);
      form.append("leave_count", item.leavecount);
      form.append("approved_by", context.user.id);
      form.append("totalcount", totalCount);
      form.append("approvalcount", item.approvalcount);
      form.append("department", context.user.emp_academic_department);
      form.append("approved_status", 1);

      return axios.post(ServiceUrl.MOB.EMP_LEAVE_APPROVAL, form);
    });

    Promise.all(approvalPromises)
      .then((results) => {
        const successCount = results.filter(res => res.data.status == "1").length;
        Toast.show({ content: `Successfully Approved` });

        getReport();
        setSelectedLeaves([]);
      })
      .catch((error) => {
        Toast.show({ content: "An error occurred while processing approvals." });
        console.error(error);
      });
  };

  const calculateDays = (e, leavect, fdate) => {
    setToDate(e);
    let startDay;
    if (fdate) startDay = new Date(fdate);
    else startDay = new Date(fromDate);

    const endDay = new Date(e);
    let count = 0;

    for (let d = startDay; d <= endDay; d.setDate(d.getDate() + 1)) {
      const currentDate = d.toISOString().split("T")[0];
      if (!holidays.some((holiday) => holiday.holiday_date === currentDate)) {
        count++;
      }
    }

    if (day == "fullday") {
      if (leavect >= 0 && leavect != "") {
        setPendingCount(Math.max(0, leavect - count));
      } else {
        setPendingCount(Math.max(0, leaveCount - count));
      }
    } else {
      if (leavect >= 0) setPendingCount(Math.max(0, leavect - 0.5));
      else setPendingCount(Math.max(0, leaveCount - 0.5));
    }
  };
  const changeDay = (e) => {
    setDay(e);
    if (fromDate && toDate) {
      const startDay = new Date(fromDate);
      const endDay = new Date(e);
      let count = 1;

      for (let d = startDay; d <= endDay; d.setDate(d.getDate() + 1)) {
        console.log("aaa");
        const currentDate = d.toISOString().split("T")[0];
        if (!holidays.some((holiday) => holiday.holiday_date === currentDate)) {
          count++;
        }
      }
      console.log(count);
      if (e == "fullday") {
        setPendingCount(Math.max(0, leaveCount - count));
      } else {
        setPendingCount(Math.max(0, leaveCount - 0.5));
      }
    }
  };

  const handleCheckboxChange = (itemId) => {
    setSelectedLeaves((prev) =>
      prev.includes(itemId)
        ? prev.filter((id) => id !== itemId) 
        : [...prev, itemId] 
    );
  };

  const handleCheckAll = (event) => {
    if (event.target.checked) {
      const allLeaveIds = employeeLeaves.map((item) => item.id);
      setSelectedLeaves(allLeaveIds);
    } else {
      setSelectedLeaves([]);
    }
  };

  return (
    <>
      <Header title="Leave Request" backAction={true} rightActions={[]} />
      <div className="container leave">
        <Tabs
          className="bg-white"
          activeKey={activeTab}
          onChange={(k) => setActiveTab(k)}
        >
          <Tabs.Tab title={<>My Leaves</>} key="myleave" />
          {rolesAccess && (
            <Tabs.Tab
              title="Staff Leaves waiting for your approval"
              key="staffleave"
            />
          )}
        </Tabs>
      </div>
      <Spin spinning={loader}>
        {showList && activeTab == "myleave" && (
          <div>
            <div className="container">
              <Card className="mb-2">
                <Card.Header style={{ position: "relative" }}>
                  <h6>LEAVE </h6>
                  <FloatButton
                    icon={<img src={MOB_ICONS.ADD_BUTTON} />}
                    type="default"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "absolute",
                      top: "50%",
                      right: 24,
                      transform: "translateY(-50%)",
                      width: "32px",
                      height: "32px",
                    }}
                    onClick={() => {
                      setShowList(false);

                      setShowForm(true);
                    }}
                  />
                </Card.Header>
                <Card.Body className="fs-6">
                  <List>
                    {dataView.map((item, index) => (
                      <List.Item
                        key={index + 1}
                        onClick={(e) => {
                          handleView(item);
                          setShowList(false);
                          setShowForm(false);
                          setShowListView(true);
                          setDay(item.day);
                        }}
                        prefix={
                          <Avatar
                            style={{
                              backgroundColor: "#f56a00",
                              verticalAlign: "middle",
                              textTransform: "uppercase",
                            }}
                            size="large"
                          >
                            {parseInt(item.approved) ? "A" : "W"}
                          </Avatar>
                        }
                      >
                        {item.leave_type} {/* */}
                        <Space size={[0, 8]} wrap>
                          {item.approved == "0" ? (
                            <Tag color="red">Rejected</Tag>
                          ) : item.approved == "1" ? (
                            <Tag color="green">Approved</Tag>
                          ) : (
                            <Tag color="orange">Waiting for approval</Tag>
                          )}
                        </Space>
                        <br />
                        <span style={{ fontSize: "13px" }}>
                          {momentDate(item.from_date, "DD/MM/YYYY")} to&nbsp;
                          {momentDate(item.to_date, "DD/MM/YYYY")}
                        </span>
                      </List.Item>
                    ))}
                  </List>
                </Card.Body>
              </Card>
            </div>
          </div>
        )}

        {rolesAccess && activeTab == "staffleave" && (
          <div>
            <div className="container staff">
              <Card className="mb-2">
                <Card.Header
                  style={{
                    position: "relative",
                    background: " #fff",
                    paddingTop: "15px",
                  }}
                >
                  <h6>STAFF LEAVE APPROVAL </h6>
                </Card.Header>
                <Card.Body className="fs-6">
                {context.user.role_name.includes("Principal") && (
                    <Button
                      variant="success"
                      size="sm"
                      onClick={approveSelectedLeaves}
                      style={{ float: "right" }}
                    >
                      Accept Selected
                    </Button>
                  )}

                  {context.user.role_name.includes("Principal") && (
                    <Form.Check
                      type="checkbox"
                      label={<span style={{ fontSize: '14px', color: '#000' }}>Check All</span>}
                      onChange={handleCheckAll}
                      checked={selectedLeaves.length === employeeLeaves.length && employeeLeaves.length > 0}
                    />
                  )}

                  <table>
                    <thead>
                      <tr>
                      {context.user.role_name.includes("Principal") && (
                          <th scope="col">Select</th>
                        )}
                        <th scope="col">Name</th>
                        <th scope="col">Department</th>
                        <th scope="col">Period</th>
                        <th scope="col">Type</th>
                        <th scope="col">Approval</th>
                      </tr>
                    </thead>
                    <tbody>
                      {employeeLeaves &&
                        employeeLeaves.length > 0 &&
                        employeeLeaves.map((item) => (
                          <tr key={item.id}>
                             {context.user.role_name.includes("Principal") && (
                              <td data-label="Select"
                                style={{
                                  backgroundColor: selectedLeaves.includes(item.id) ? '#d4edda' : 'transparent'
                                }}
                              >
                                <Form.Check
                                  type="checkbox"
                                  checked={selectedLeaves.includes(item.id)}
                                  onChange={() => handleCheckboxChange(item.id)}
                                />
                              </td>
                            )}
                            <td data-label="Name">{item.emp_name}</td>
                            <td data-label="Department">
                              {item.academic_dept_name}
                            </td>
                            <td data-label="Period">
                              {" "}
                              {momentDate(item.from_date, "DD/MM/YYYY")} -{" "}
                              {momentDate(item.to_date, "DD/MM/YYYY")}
                            </td>
                            <td data-label="Type">{item.leave_type}</td>
                            <td data-label="Approval">
                              {item.approved_status != null ? (
                                item.approved == 1 ? (
                                  <>
                                    <img
                                      src={MOB_ICONS.APPROVED}
                                      style={{ width: "60%" }}
                                    />
                                  </>
                                ) : (
                                  <>
                                    {/*  <img
                                      src={MOB_ICONS.REJECTED}
                                      style={{ width: "60%" }}
                                    /> */}

                                    {/* <span
                                      style={{ color: "red", fontSize: "bold" }}
                                    >
                                      {item.reasons}
                                    </span> */}
                                  </>
                                )
                              ) : (
                                <>
                                  {item.approved_status == 2 && (
                                    <img
                                      src={MOB_ICONS.REJECTED}
                                      style={{ width: "60%" }}
                                    />
                                  )}
                                </>
                              )}
                              {context.user.role_name.includes("Principal") &&
                              item.approved == 2 &&
                              (item.approved_status == null ||
                                item.approved_status == 0) ? (
                                <>
                                  <a
                                    onClick={(e) =>
                                      handleApproval("approved", item)
                                    }
                                  >
                                    <img
                                      src={MOB_ICONS.ACCEPT_BUTTON}
                                      style={{ width: "60%" }}
                                    />
                                  </a>
                                  &nbsp;
                                  <a
                                    onClick={(e) =>
                                      handleApproval("rejected", item)
                                    }
                                  >
                                    <img
                                      src={MOB_ICONS.REJECT_BUTTON}
                                      style={{ width: "60%" }}
                                    />
                                  </a>{" "}
                                  <br />
                                </>
                              ) : (
                                ""
                              )}
                              {(context.user.role_name.includes("HOD") ||
                                context.user.role_name.includes("HEAD")) &&
                              item.approved == 2 &&
                              item.approved_status == null ? (
                                <>
                                  <a
                                    onClick={(e) =>
                                      handleHODApproval("approved", item)
                                    }
                                  >
                                    <Button
                                      type="button"
                                      variant="success"
                                      className="btn btn-block "
                                    >
                                      Endorse{" "}
                                    </Button>
                                  </a>
                                </>
                              ) : (
                                <span
                                  style={{ color: "red", fontSize: "bold" }}
                                >
                                  {item.reasons ? item.reasons : item.reason}
                                </span>
                              )}
                              {item.approved == 1 &&
                                item.approved_status == null && (
                                  <>
                                    <img
                                      src={MOB_ICONS.APPROVED}
                                      style={{ width: "60%" }}
                                    />
                                  </>
                                )}
                              {item.approved == 0 &&
                                item.approved_status == null && (
                                  <img
                                    src={MOB_ICONS.REJECTED}
                                    style={{ width: "60%" }}
                                  />
                                )}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </Card.Body>
              </Card>
            </div>
          </div>
        )}

        {showForm && (
          <div>
            <div className="container">
              <Card className="mb-2">
                <Card.Header style={{ position: "relative" }}>
                  <h6>ADD LEAVE </h6>
                  <FloatButton
                    icon={<img src={MOB_ICONS.CLOSE_BUTTON} />}
                    type="default"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "absolute",
                      top: "50%",
                      right: 24,
                      transform: "translateY(-50%)",
                      width: "32px",
                      height: "32px",
                    }}
                    onClick={() => {
                      setShowForm(false);
                      setShowList(true);
                    }}
                  />
                </Card.Header>
                <Card.Body>
                  <Form noValidate id="frm_add" onSubmit={handleSubmit}>
                    <input
                      type="hidden"
                      name="staff_id"
                      value={context.user.id}
                    />
                    <input
                      type="hidden"
                      name="emp_code"
                      value={context.user.emp_code}
                    />
                    <input
                      type="hidden"
                      name="emp_name"
                      value={context.user.emp_name}
                    />
                    <input type="hidden" name="approved" value={2} />
                    <input
                      type="hidden"
                      name="cl_limit_permonth"
                      value={context.settingValue(
                        "casual_leave_allowed_permonth"
                      )}
                    />
                    <Row className="mt-2">
                      <Col md={3}>
                        <label className="fs-sm">
                          Leave Type <span className="text-danger">*</span>
                        </label>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          as="select"
                          className="fw-bold form-select form-select-sm"
                          size="sm"
                          name="leave_type"
                          onChange={(e) => onLeaveChange(e.target.value)}
                        >
                          <option value="">-Select-</option>
                          {leaveTypes.map((item) => (
                            <option value={item.leave_type}>
                              {item.leave_type}
                            </option>
                          ))}
                        </Form.Control>
                      </Col>
                    </Row>

                    <Row className="mt-2">
                      <Col md={3}>
                        <label className="fs-sm">
                          Day <span className="text-danger">*</span>
                        </label>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          as="select"
                          className="fw-bold form-select form-select-sm"
                          size="sm"
                          name="day"
                          onChange={(e) => changeDay(e.target.value)}
                          required
                        >
                          <option value="">-Select-</option>
                          <option value="fullday">Full Day</option>
                          <option value="morning">Forenoon</option>
                          <option value="afternoon">Afternoon</option>
                        </Form.Control>
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col md={3}>
                        <label className="fs-sm">
                          Total Leaves <span className="text-danger">*</span>
                        </label>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          type="text"
                          className="fw-bold text-uppercase"
                          size="sm"
                          name="total_leaves"
                          value={leaveCount}
                        />
                      </Col>
                    </Row>
                    <Row className="mt-2">
                      <Col md={3}>
                        <Form.Label className="fs-sm">
                          From date <span className="text-danger">*</span>
                        </Form.Label>
                      </Col>
                      <Col md={5}>
                        <Form.Control
                          type="date"
                          className="fw-bold text-uppercase mt-2"
                          size="sm"
                          name="from_date"
                          onChange={(e) => {
                            setFromDate(e.target.value);
                            calculateDays(e.target.value, "", e.target.value);
                          }}
                          value={fromDate}
                          required
                        />
                      </Col>
                    </Row>

                    <Row className="mt-2">
                      <Col md={3}>
                        <label className="fs-sm">
                          To date <span className="text-danger">*</span>
                        </label>
                      </Col>

                      <Col md={5}>
                        <Form.Control
                          type="date"
                          className="fw-bold text-uppercase mt-2"
                          size="sm"
                          name="to_date"
                          min={fromDate}
                          onChange={(e) => calculateDays(e.target.value)}
                          value={toDate}
                          required
                        />
                      </Col>
                    </Row>

                    <Row className="mt-2">
                      <Col md={3}>
                        <label className="fs-sm">
                          Balance Leaves <span className="text-danger">*</span>
                        </label>
                      </Col>
                      <Col md={7}>
                        <Form.Control
                          type="text"
                          className="fw-bold text-uppercase"
                          size="sm"
                          name="pending_leave"
                          value={pendingCount}
                        />
                      </Col>
                    </Row>

                    <Row className="mt-2">
                      <Col md={3}>
                        <label className="fs-sm">Reason</label>
                      </Col>
                      <Col md={5}>
                        <Form.Control
                          as="textarea"
                          name="reason"
                          className="fw-bold mt-2"
                          size="md"
                          rows="3"
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col md={3}></Col>
                      <Col md={4} className="text-end">
                        <br />
                        <Button
                          type="submit"
                          variant="success"
                          className="btn btn-block "
                        >
                          save
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </Card.Body>
              </Card>
            </div>
          </div>
        )}
        {showListView && (
          <div>
            <div className="container ">
              <Card className="mb-2">
                <Card.Header style={{ position: "relative" }}>
                  <h6> VIEW LEAVE </h6>
                  <FloatButton
                    icon={<img src={MOB_ICONS.CLOSE_BUTTON} />}
                    type="default"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      position: "absolute",
                      top: "50%",
                      right: 24,
                      transform: "translateY(-50%)",
                      width: "32px",
                      height: "32px",
                    }}
                    onClick={() => {
                      setShowListView(false);
                      setShowList(true);
                    }}
                  />
                </Card.Header>
                <Card.Body>
                  <div style={{ display: "" }}>
                    <div id="view">
                      <table
                        width="100%"
                        align="center"
                        className="font-bookman"
                        cellPadding={3}
                      >
                        <thead>
                          {context.settingValue("billheader_name") ? (
                            <>
                              {" "}
                              <tr align="center">
                                <th colSpan={3} align="center" height="30">
                                  <b>
                                    {context.settingValue("billheader_name")}
                                  </b>
                                </th>
                              </tr>
                            </>
                          ) : (
                            ""
                          )}
                        </thead>
                        <tbody>
                          <tr>
                            <td width="30%"> From Date</td>
                            <td align="center" width="10%">
                              :
                            </td>
                            <td>
                              {" "}
                              {momentDate(showView.from_date, "YYYY-MM-DD")}
                            </td>
                          </tr>
                          <tr>
                            <td width="30%"> To Date</td>
                            <td align="center" width="10%">
                              :
                            </td>
                            <td width="70%">
                              {" "}
                              {momentDate(showView.to_date, "YYYY-MM-DD")}
                            </td>
                          </tr>
                          <tr>
                            <td width="30%"> Leave Type</td>
                            <td align="center" width="10%">
                              :
                            </td>
                            <td width="70%"> {showView.leave_type}</td>
                          </tr>
                          <tr>
                            <td width="30%"> Day</td>
                            <td align="center" width="10%">
                              :
                            </td>
                            <td width="70%"> {showView.day}</td>
                          </tr>
                          <tr>
                            <td width="30%"> Reason</td>
                            <td align="center" width="10%">
                              :
                            </td>
                            <td width="70%"> {showView.reason}</td>
                          </tr>
                          <tr>
                            <td width="30%"> Leave Status</td>
                            <td align="center" width="10%">
                              :
                            </td>
                            <td width="70%">
                              {" "}
                              {showView.approved == 1 ? "Approved" : "Waiting"}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </div>
        )}
      </Spin>
    </>
  );
};
export default MyLeaveList;
